// Intent: [Journey] [SEO/GEO] [Trust]
import React from "react";
import { ButtonLink } from "../components/shared/ButtonLink";
import { PageHero } from "../components/shared/PageHero";
import { TutorialLibrary } from "../components/shared/TutorialLibrary";
import type { Tutorial } from "../components/shared/TutorialLibrary";
const tutorials: readonly Tutorial[] = [{
  id: "KRddHoDZV9s",
  title: "Base 4 Drawer",
  description: "Configure a four-drawer base cabinet."
}, {
  id: "CciezxyX0Tc",
  title: "Base Bin Unit",
  description: "Configure a base cabinet for a bin unit."
}, {
  id: "EuPRS6ysJhg",
  title: "Base 2 Door",
  description: "Configure a two-door base cabinet."
}, {
  id: "4Hzv68Kpoe4",
  title: "Base Corner L-Shape",
  description: "Configure an L-shaped corner cabinet."
}, {
  id: "O5g1u6JlWrY",
  title: "Base Oven",
  description: "Configure an under-bench oven cabinet."
}, {
  id: "gm4hIZPniwE",
  title: "Base Single Door",
  description: "Configure a single-door base cabinet."
}, {
  id: "7rC-UbqumbU",
  title: "Tall Pantry & Upper",
  description: "Configure tall and overhead storage."
}, {
  id: "jH1guQfOCuo",
  title: "Upper Single Door",
  description: "Configure a single-door upper cabinet."
}, {
  id: "h81aBlDtNQs",
  title: "Rangehood Cabinet",
  description: "Configure an upper rangehood cabinet."
}, {
  id: "qShITjwRoYM",
  title: "Upper 2 Door",
  description: "Configure a two-door upper cabinet."
}, {
  id: "oG6LHr7CneU",
  title: "Panels & Fillers",
  description: "Add the finishing components to the job."
}, {
  id: "w7U5130Epd4",
  title: "Kickboards",
  description: "Add and configure cabinet kickboards."
}];
function DesignAndOrderGuidePage() {
  return <main id="main-content" data-id="element-305" data-mp="39zllllr2hus9">
      <PageHero eyebrow="Video guide" title="Design and order your cabinets." copy="Choose a cabinet type to watch how it is configured in Cabinetry.Online." data-id="element-306" data-mp="3es6d2gmi3vsm">
        <ButtonLink href="/register/" data-id="element-307" data-mp="2iaa3aarbn92u">Choose Your Account</ButtonLink>
      </PageHero>
      <section className="section-shell bg-[#eceae4]" data-id="element-308" data-mp="2makk6ignjjwh"><div className="container-shell" data-id="element-309" data-mp="3pn1ak4wdxqsf"><TutorialLibrary tutorials={tutorials} label="Ordering tutorial" data-id="element-310" data-mp="3plzoz6hqtlwg" /></div></section>
      <section className="bg-pfpc-navy py-9 text-pfpc-offwhite" data-id="element-311" data-mp="3koq3g1xh5udw"><div className="container-shell flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-312" data-mp="3klu2s5u8srlr"><div data-id="element-313" data-mp="39je8wmufyd6"><h2 className="font-heading text-[26px] font-extrabold" data-id="element-314" data-mp="399iesf4awzk">Ready to start your own job?</h2><p className="mt-2 text-[14px] text-pfpc-offwhite/68" data-id="element-315" data-mp="3ufui10j8nd87">Choose the account pathway that suits the project.</p></div><ButtonLink href="/register/" data-id="element-316" data-mp="36q04shv0bmnf">Register</ButtonLink></div></section>
    </main>;
}
export { DesignAndOrderGuidePage };